
import ImageSources from '@/mixins/srcset';
export default {
  mixins: [ImageSources],
  props: {
    aspectRatio: { type: Number, default: 16 / 9 },
    heading: { type: String, default: null },
    subheading: { type: String, default: null },
    alt: { type: String, default: '' },
    contain: { type: Boolean, default: undefined },
    gradient: {
      type: String,
      default: 'rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)',
    },
    width: { type: [Number, String], default: null },
    height: { type: [Number, String], default: null },
    color: {
      type: String,
      default: null,
    },
    src: {
      type: String,
      default: '/v1559982334/hero_rko6us.jpg',
    },
  },
  head() {
    return {
      meta: [
        {
          hid: 'og:image',
          property: 'og:image',
          content: `${this.$config.BASE_URL}${this.$img(
            this.src,
            {},
            { preset: 'og' },
          )}`,
        },
        {
          hid: 'og:image:width',
          property: 'og:image:width',
          content: 1280,
        },
        {
          hid: 'og:image:height',
          property: 'og:image:height',
          content: 630,
        },
      ],
      link: [
        {
          rel: 'preload',
          as: 'image',
          href: `${this.$config.BASE_URL}${this.$img(
            this.src,
            {},
            { preset: 'hero' },
          )}`,
          imagesrcset: this._srcset.srcset,
          imagesizes: this._srcset.size,
        },
      ],
    };
  },
};
